var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPush12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_735_1293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 5.6545V12H6.00887C4.83836 11.9994 3.69358 11.6565 2.71552 11.0135C1.73747 10.3705 0.968862 9.45538 0.50437 8.38098C0.0398773 7.30658 -0.100212 6.11978 0.101357 4.96676C0.302925 3.81374 0.837348 2.74486 1.6388 1.89177C2.44025 1.03868 3.47373 0.438646 4.61193 0.165569C5.75014 -0.107508 6.94337 -0.0416978 8.04464 0.354893C9.14591 0.751483 10.1071 1.46153 10.8099 2.39758C11.5127 3.33364 11.9263 4.45481 11.9999 5.623V5.6545ZM6.49987 3.5H3.49987V4.5H6.49987V3.5ZM8.49987 5.5H3.49987V6.5H8.49987V5.5ZM8.49987 7.5H3.49987V8.5H8.49987V7.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_1293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPush12);
export default __webpack_public_path__ + "static/media/Push12.c36c0e1a4e62ebe22e511d23a57b94df.svg";
export { ForwardRef as ReactComponent };